import { render } from "./LogoMenu.vue?vue&type=template&id=06ca944c&scoped=true"
import script from "./LogoMenu.vue?vue&type=script&lang=js"
export * from "./LogoMenu.vue?vue&type=script&lang=js"

import "./LogoMenu.vue?vue&type=style&index=0&id=06ca944c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ca944c"]])

export default __exports__